import type { Formato, RevisionDeContactos } from '@/api/importacion.api';

/** Ayudantes de «Importar contactos» (tanda 3, Ola D). PUROS. */

/** El formato por la extensión. Un .xls viejo no: exceljs solo lee .xlsx. */
export function formatoDeArchivo(nombre: string): Formato | null {
  const n = nombre.toLowerCase();
  return n.endsWith('.xlsx') ? 'xlsx' : n.endsWith('.csv') ? 'csv' : null;
}

/** T14: la fuente que se propone para un archivo: su nombre sin la extensión ni los guiones bajos, hasta 60. */
export function fuenteDelArchivo(nombre: string): string {
  return nombre
    .replace(/\.[^.]+$/, '')
    .replace(/_+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 60);
}

/** El .xlsx viaja en base64 dentro del JSON. */
export function aBase64(bytes: ArrayBuffer | Uint8Array): string {
  const u = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  let s = '';
  // De a pedazos: String.fromCharCode con el archivo entero desborda la pila.
  for (let i = 0; i < u.length; i += 0x8000) s += String.fromCharCode(...u.subarray(i, i + 0x8000));
  return btoa(s);
}

/** Cambia adónde va una columna. Un destino va a una sola columna: si otra lo tenía, lo suelta. */
export function cambiarMapeo(mapeo: Record<string, string>, columna: string, destino: string): Record<string, string> {
  const m: Record<string, string> = {};
  for (const [c, d] of Object.entries(mapeo)) m[c] = destino && d === destino ? '' : d;
  m[columna] = destino;
  return m;
}

/** «2 nuevos · 1 ya estaba · 1 con baja (no se importa) · 2 con problemas». */
export function textoDelResumen(r: RevisionDeContactos['resumen']): string {
  const partes = [`${r.nuevos} nuevo${r.nuevos === 1 ? '' : 's'}`];
  if (r.yaEstan) partes.push(`${r.yaEstan} ya estaba${r.yaEstan === 1 ? '' : 'n'}`);
  if (r.bajas) partes.push(`${r.bajas} con baja (no se importa${r.bajas === 1 ? '' : 'n'})`);
  if (r.malas) partes.push(`${r.malas} con problemas`);
  return partes.join(' · ');
}
